import script from "./TagsList.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsList.vue?vue&type=script&setup=true&lang=js"

import "./TagsList.vue?vue&type=style&index=0&id=c1f092a0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1f092a0"]])

export default __exports__